import React, { useRef } from "react";
import { Link } from "react-router-dom";
import "./FeaturedCarousel.css";

/**
 * Horizontally scrollable, fanned/overlapping card carousel for the home
 * page. Cards drag-scroll (touch or mouse wheel), and the prev/next
 * buttons nudge by one card width for keyboard/mouse users.
 */
function FeaturedCarousel({ items }) {
  const trackRef = useRef(null);

  function scrollByCard(direction) {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector(".tt-carousel-card");
    const cardWidth = card ? card.offsetWidth + 24 : 260;
    track.scrollBy({ left: direction * cardWidth, behavior: "smooth" });
  }

  if (!items || items.length === 0) return null;

  return (
    <div className="tt-carousel">
      <button
        type="button"
        className="tt-carousel-nav tt-carousel-nav-prev"
        onClick={() => scrollByCard(-1)}
        aria-label="Scroll left"
      >
        &#8249;
      </button>

      <div className="tt-carousel-track" ref={trackRef}>
        {items.map((news) => (
          <Link
            key={`${news.categorySlug}-${news.id}`}
            to={`/news/${news.categorySlug}/${news.id}`}
            className="tt-carousel-card"
          >
            {news.image ? (
              <img src={news.image} alt={news.title} className="tt-carousel-card-img" loading="lazy" />
            ) : (
              <div className="tt-carousel-card-img tt-carousel-card-img-fallback" aria-hidden="true" />
            )}
            <div className="tt-carousel-card-overlay">
              <span className="tt-carousel-card-category">{news.category}</span>
              <p className="tt-carousel-card-title">{news.title}</p>
            </div>
          </Link>
        ))}
      </div>

      <button
        type="button"
        className="tt-carousel-nav tt-carousel-nav-next"
        onClick={() => scrollByCard(1)}
        aria-label="Scroll right"
      >
        &#8250;
      </button>
    </div>
  );
}

export default FeaturedCarousel;
